import React from 'react';
import { useSelector } from 'react-redux';
import StatsCards from '../components/dashboard/StatsCards';
import LoanStatsBySchoolYear from '../components/dashboard/LoanStatsBySchoolYear';
import RecentActivity from '../components/dashboard/RecentActivity';
import PopularBooks from '../components/dashboard/PopularBooks';

import FavoriteBooks from '../components/dashboard/FavoriteBooks';

export default function Dashboard({ onNavigate }) {
    //console.log("Dashboard");
    const { items: allBooks } = useSelector((state) => state.books);
    const hasFavorites = allBooks.some(book => book.rating === "true");

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between">
                <div>
                    <h2 className="text-3xl font-bold text-white">Tableau de bord</h2>
                    <p className="text-slate-400 mt-1">Aperçu des performances de votre bibliothèque</p>
                </div>
                <div className="flex items-center gap-3">
                    <span className="text-sm text-slate-400">Dernière mise à jour : À l'instant</span>
                </div>
            </div>

            <StatsCards onNavigate={onNavigate} />

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-2 flex flex-col gap-6">
                    {hasFavorites && (
                        <div className="flex-1 min-h-0">
                            <FavoriteBooks onNavigate={onNavigate} />
                        </div>
                    )}
                    <div className="flex-1 min-h-0">
                        <PopularBooks onNavigate={onNavigate} />
                    </div>
                </div>
                <div className="flex flex-col">
                    <RecentActivity onNavigate={onNavigate} />
                </div>
            </div>
            <LoanStatsBySchoolYear />
        </div>
    );
}
